import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-chair-workouts',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-chair-workouts-m', 'age-chair-workouts-m'],
		route: {
			path: '/chair-workouts-m',
			name: 'male-chair-workouts-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'male_funnel', // /chair-workouts-m?safe&lptype=male_funnel&lpid=
				},
				ids: ['dynamic-loader-male-light', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-male-chair-workouts',
		route: {
			path: '/chair-workouts-m/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'male-activity-chair-workouts',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'male-activity-chair-workouts',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-chair-workouts-m',
	},
	upsell: {
		routeNames: ['upsell-activity-m'],
		overrides: [
			{
				matcher: { country: 'us' },
				routeNames: ['upsell-yoga-m-us'],
			},
		],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
